import React from 'react'

function WhoCanBenefit() {
   return (
      <section className="section_primary_bg second-section">
         <div className="container who-benefits-umbrell">
            <h2>
               Who Can Benefit From Benzatine's Public Sector And
               <br />
               Government Solutions?
            </h2>
            <p>
               We at Benzatine are experts in leveraging the latest technologies
               to revolutionize the effectiveness of government services. Our
               solutions target improving user experiences, automating
               procedures, and increasing operational productivity. We operate
               in various government agencies, maintaining high security and
               availability while bringing about significant improvements in
               numerous public services.
            </p>

            <img
               src="/assets/svg/industries/gov-public/gov-image.svg"
               alt="gov"
               className="m-auto govt-umbrella"
            />
         </div>
      </section>
   )
}

export default WhoCanBenefit
